// import React from 'react'

// function Lateattendance() {
//   return (
//     <div>Lateattendance</div>
//   )
// }

// export default Lateattendance

import React, { useCallback } from 'react'
import AuthNavbar from "../components/AuthNavbar/AuthNavbar"
import HomeTitle from "../components/HomeTitle/HomeTitle"
import CustomTable from "../components/CustomTable/CustomTable"
import {  Col, Container, Row } from "react-bootstrap"
import { useEffect, useState } from "react"
import axios from "axios"
import { useSelector } from "react-redux"
import CustomBtn from '../components/CustomBtn/CustomBtn'
import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import Select from 'react-select';

export default function Lateattendance() {
    const userinfo = useSelector((state) => state);
    const [class_id, setClass_id] = useState('')
    const [classItems, setClassItems] = useState([])
    const [sessionsItems, setSessionsItems] = useState([])
    const [studentsItems, setStudentsItems] = useState([])
    const [selectedSemesterId, setSelectedSemesterId] = useState('')
    const [session_id, setSession_id] = useState('')
    const [sessionID, setSessionID] = useState('')

    const [attendance, setAttendance] = useState({});
    const [stageLoading, setStageLoading] = useState('')
    const year = new Date().getFullYear();
    const today = new Date();
    const dayName = today.toLocaleDateString('en-US', { weekday: 'long' });
          const { currentLocal } = useSelector((state) => state.currentLocal);
    

    const headerIterm = [
        currentLocal.home.ID,
        currentLocal.home.namePlaceholder,
        currentLocal.home.status
    ]
    const options = [
        { value: 'first', label:  currentLocal.home.firstsemster },
        { value: 'second', label:  currentLocal.home.secondsemester},
    ];
    const getAllApis = useCallback(async () => {

        await axios
            .get(`https://nanosoft.technology/taarteb/api/classes`, {
                headers: {
                    Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
                }
            })
            .then(async (res) => {
                const options = res.data.data.data.map(item => ({
                    value: item.id, 
                    label: item.name
                }));

                setClassItems(options);


            })
            .catch((error) => {

                



            });
if(class_id){
await axios
.get(`https://nanosoft.technology/taarteb/api/sessions?class_id=${class_id.value}`, {
    headers: {
        Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
    }
})
.then(async (res) => {
    const today = new Date().toLocaleString('en-US', { weekday: 'long' }).toLowerCase();
const todaySessions = res.data.data.data.filter(
(session) => 
  session.day.toLowerCase() === today && 
  session.semester === (selectedSemesterId?.value)
);
    setSessionsItems(res.data.data.data)
    const options = todaySessions.map(item => ({
        value: item.session_number, 
        label: item.session_number ,
        id: item.id ,
    }));

    setSessionsItems(options);


})
.catch((error) => {

    



});
}
        if (class_id && selectedSemesterId&&session_id) {
            await axios
                .get(`https://nanosoft.technology/taarteb/api/attendances?class_id=${class_id.value}&year=${year}&day=${dayName.toLowerCase()}&semester=${selectedSemesterId.value}&session_number=${session_id.value}`, {
                    headers: {
                        Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
                    }
                })
                .then(async (res) => {
                    setStudentsItems(res.data.data.students)


                })
                .catch((error) => {

                    



                });
        }

    }, [class_id, selectedSemesterId,session_id,userinfo.auth.userArray.access_token,year]);

    useEffect(() => {

 
        getAllApis()

    }, [getAllApis])

    const SaveAtt = async (e) => {
        e.preventDefault();
delete attendance.session_id;

const x = attendance?.attendance
  ?.filter(item => item.is_present === 0) // keep only present students
  ?.map(({ is_present, ...rest }) => rest); // remove is_present field

const idsOnly = x?.map(item => item.student_id);

console.log(x);
console.log(idsOnly);
        setStageLoading(true)
        const toastId = "attendance-toast";
        try {
            const response = await axios.post('https://nanosoft.technology/taarteb/api/attendances/late-attendance-message', {ids:idsOnly}, {
                headers: { Authorization: `Bearer ${userinfo.auth.userArray.access_token}` },
            });

            toast.success(response.data.message, { toastId,position: "bottom-right", autoClose: 2000 });
            setClass_id('')
            setSelectedSemesterId('')
            setSession_id('')
            setStageLoading(false)
        } catch (error) {
            console.error("Error:",toastId, error.response?.data || error.message);
            toast.error("Failed to submit attendance!");
            setStageLoading(false)

        }

    }

    const submitAttendance = async (attendanceData) => {
        
        setAttendance(attendanceData)
    };

    return (
        <>
            <ToastContainer />
            <div className="px-0 my-3 w-100 dashboard_content">
                <Container>
                    <div className="d-flex flex-column w-100">
                        <AuthNavbar />
                        <div className="mt-5 mx-3">
                            <HomeTitle title={currentLocal.home.Lateattendance} />
                            <Row>
                                <Col md={4}>
                                    <div className='mb-3'>
                                        <Select
                                            value={class_id}
                                            onChange={(selectedOption) => setClass_id(selectedOption)}
                                            options={classItems}
                                            placeholder={currentLocal.home.SelectClass} 

                                        />
                                    </div>

                                </Col>
                                <Col md={4}>
                                    <div className='mb-3'>
                                        <Select
                                            value={selectedSemesterId}
                                            onChange={(selectedOption) => setSelectedSemesterId(selectedOption)}
                                            options={options}
                                            placeholder={currentLocal.home.SelectSemester}
                                        />
                                    </div>
                     
                                </Col>
                                <Col md={4}>
           
                                    <div className='mb-3'>
                                        <Select
                                            value={session_id}
                                            onChange={(selectedOption) =>{
                                                setSessionID(selectedOption.id)
                                                setSession_id(selectedOption)
                                              }}
                                            options={sessionsItems}
                                            placeholder={currentLocal.home.SelectSession}

                                        />
                                    </div>
                                </Col>
                            </Row>

                            <CustomTable
                                data={studentsItems}
                                headerIterm={headerIterm}
                                onSubmitAttendance={submitAttendance} 
                                session_id={session_id.value}
                                sessionID={sessionID}


                            />
                            {class_id && selectedSemesterId&&session_id&&studentsItems.length!==0&&
                                <div className='d-flex justify-content-center mt-4'>
                                    <div className='w-50 save_btn'>
                                        <CustomBtn text={stageLoading ? currentLocal.home.Loading : currentLocal.home.Save} disabled={stageLoading}  clickingFunction={SaveAtt} customWidth={"100%"}/>

                                    </div>
                                </div>
                            }


                        </div>

                    </div>
                </Container>
            </div>
        </>
    )
}
